import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({ startOnLoad: true });

const MermaidComponent = ({ chart }) => {
  const ref = useRef(null);

  useEffect(() => {
    mermaid.contentLoaded();
  }, [chart]);

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100 p-4">
      <div
        className="mermaid bg-white shadow-lg rounded-4xl flex justify-center items-center p-6 max-w-7xl w-full h-auto overflow-auto"
        ref={ref}
      >
        {chart}
      </div>
    </div>
  );
};

export default MermaidComponent;
